<div *ngIf="showSkeleton && isLoading" class="container-fluid mt-4">
	<div *ngIf="showSkeleton" class="container-fluid mt-4">
		<ng-container *ngIf="skeletonType === 'dashboard'">
			<ng-template [ngTemplateOutlet]="skeletonDashboard"></ng-template>
		</ng-container>

		<ng-container *ngIf="skeletonType === 'generic'">
			<ng-template [ngTemplateOutlet]="skeletonGeneric"></ng-template>
		</ng-container>
	</div>
</div>

@if (customIframe()) {
	<iframe
		#iframe
		scrolling="no"
		[src]="urlToRender | iframeSanitizer"
		(load)="onLoad(iframe)"
		class="h-100 w-100"
		[ngClass]="{ invisible: isLoading, visible: !isLoading }"
		data-hj-allow-iframe="true"
	></iframe>
} @else {
	<div class="ratio {{ aspectRatio }} ratio-responsive iframe-container">
		<iframe
			#iframe
			[src]="urlToRender | iframeSanitizer"
			(load)="onLoad(iframe)"
			[ngClass]="{ invisible: isLoading, visible: !isLoading }"
			data-hj-allow-iframe="true"
		></iframe>
	</div>
}

<ng-template #skeletonDashboard>
	<div class="skeleton-dashboard">
		<div class="body-row">
			<ng-container *ngFor="let _ of [1, 2, 3, 4, 5]">
				<div
					*appSkeleton="
						isLoading;
						height: '100px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
			</ng-container>
		</div>

		<div class="body-row atlas-spacing-mt-3" style="width: 100%">
			<div></div>

			<div
				*appSkeleton="
					isLoading;
					height: '520px';
					className: 'atlas-spacing-mx-2'
				"
			></div>

			<div class="body-column">
				<div
					*appSkeleton="
						isLoading;
						height: '96px';
						width: '420px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
				<div
					*appSkeleton="
						isLoading;
						height: '190px';
						width: '420px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
				<div
					*appSkeleton="
						isLoading;
						height: '190px';
						width: '420px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
			</div>
		</div>

		<div class="body-row atlas-spacing-mt-3">
			<ng-container *ngFor="let _ of [1, 2, 3, 4, 5]">
				<div
					*appSkeleton="
						isLoading;
						height: '180px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #skeletonGeneric>
	<div class="skeleton-generic">
		<div class="body-column">
			<div class="body-row">
				<div
					*appSkeleton="
						isLoading;
						height: '32px';
						width: '344px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
				<div
					*appSkeleton="
						isLoading;
						height: '48px';
						width: '200px';
						className: 'atlas-spacing-mx-2'
					"
				></div>
			</div>

			<div class="atlas-spacing-mt-3 atlas-spacing-mx-2">
				<div
					*appSkeleton="isLoading; height: '470px'; width: '100%'"
				></div>
			</div>
		</div>
	</div>
</ng-template>
